// const HeroSection = ({ image, title, subtitle, buttons = [], id }) => {
//   return (
//     <section
//       id={id}
//       className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden"
//       style={{
//         backgroundImage: `url(${image})`,
//         backgroundRepeat: "no-repeat",
//         backgroundSize: "cover",
//         backgroundAttachment: "scroll",
//       }}
//     >
//       {/* <img
//         src={image}
//         alt={title}
//         className="absolute inset-0 w-full h-full object-cover"
//         width={1920}
//         height={1080}
//       /> */}
//       <div className="hero-overlay absolute inset-0" />
//       <div className="relative z-10 text-center px-8 md:px-12 fade-in-up max-w-4xl mx-auto">
//         <h1
//           className="font-heading text-3xl md:text-5xl lg:text-6xl tracking-wide text-foreground uppercase mb-8"
//           style={{ lineHeight: "1.3" }}
//         >
//           {title}
//         </h1>
//         {subtitle && (
//           <p className="font-body text-sm md:text-base text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed">
//             {subtitle}
//           </p>
//         )}
//         {buttons.length > 0 && (
//           <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
//             {buttons.map((btn) => (
//               <a
//                 key={btn.label}
//                 href={btn.href}
//                 className="px-6 md:px-8 py-2.5 md:py-3 rounded-full border border-foreground/40 text-xs md:text-sm font-body font-medium uppercase tracking-widest text-foreground hover:bg-foreground hover:text-background transition-all duration-300"
//               >
//                 {btn.label}
//               </a>
//             ))}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default HeroSection;

import { useEffect, useRef } from "react";
const HeroSection = ({ image, title, subtitle, subtitle2, buttons = [], id }) => {
  const bgRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!bgRef.current) return;
      const scrollY = window.scrollY;
      bgRef.current.style.transform = `translateY(${scrollY * -0.4}px)`;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <section
      id={id}
      className="relative w-full h-screen min-h-[600px] flex items-center justify-center"
    >
      <div
        ref={bgRef}
        className="absolute inset-0 w-full"
        style={{
          backgroundImage: `url(${image})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          top: "-20%",
          height: "140%",
          willChange: "transform",
          transition: "transform .5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        }}
      />
      <div className="hero-overlay absolute inset-0" />
      <div className="relative z-10 text-center px-8 md:px-12 fade-in-up max-w-7xl mx-auto">
        <h1
          className="max-w-2xl mx-auto font-heading  md:text-3xl  tracking-wide text-foreground uppercase mb-8"
          style={{ lineHeight: "1.3" }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="font-body text-sm md:text-base text-muted-foreground max-w-7xl mx-auto font-semibold mt-3  leading-relaxed">
            {subtitle}
          </p>
        )}
        {subtitle2 && (
          <p className="font-body text-sm md:text-base text-muted-foreground max-w-7xl mx-auto font-semibold mb-10 leading-relaxed uppercase">
            {subtitle2}
          </p>
        )}
        {buttons.length > 0 && (
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
            {buttons.map((btn) => (
              <a
                key={btn.label}
                href={btn.href}
                className="px-6 md:px-8 py-2.5 md:py-3 rounded-full border border-foreground/40 text-xs md:text-sm font-body font-medium uppercase tracking-widest text-foreground hover:bg-foreground hover:text-background transition-all duration-300"
              >
                {btn.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
